import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.css']
})
export class ProgressCircleComponent implements OnChanges {

  @Input() PercentProgress: string;
  @Input() UniqueId: string = "1";
  constructor() { }

  ngOnChanges() {
  }

  ngAfterViewInit() {
    this.InitProgressBar();
  }

  InitProgressBar() {
    var UniqueId = this.UniqueId;
    var PercentProgress = this.PercentProgress;
    
    $(".progress-semi-circle-" + UniqueId).each(function () {

      var $bar = $(this).find(".bar-semi-circle-" + UniqueId);
      var $val = $(this).find("span.progress-value-" + UniqueId);
      var perc = parseInt(PercentProgress, 10);

      $({ p: 0 }).animate({ p: perc }, {
        duration: 1500,
        easing: "swing",
        step: function (p) {
          $bar.css({
            transform: "rotate(" + (45 + (p * 1.8)) + "deg)", // 100%=180° so: ° = % * 1.8
            // 45 is to add the needed rotation to have the green borders at the bottom
          });
          $val.text(p | 0);
        }
      });
    });

  }

}
